import { useCallback, useRef, useState } from "react";
import { shake } from "./motion";

/** Error state for an auth form. Setting a message also shakes the fields it
 *  is about: every field in the form by default, or the ones matching `target`
 *  (a selector resolved inside the form, e.g. an input or the password block). */
export function useFormError() {
  const formRef = useRef<HTMLFormElement>(null);
  const [error, setMessage] = useState<string | null>(null);

  const setError = useCallback((message: string | null, target = ".tf") => {
    setMessage(message);
    if (!message) return;
    formRef.current
      ?.querySelectorAll(target)
      .forEach((el) => shake(el.closest(".tf") ?? el));
  }, []);

  return { error, setError, formRef };
}
